import { ColDef } from "@ag-grid-community/all-modules";
import { useEffect, useState } from "react";

export default function useColumnDefinitions(builder: () => ColDef[], deps?: React.DependencyList) {
    const [cols, setCols] = useState<ColDef[]>(builder);

    useEffect(() => {
        setCols(builder());
    }, deps ?? []);

    return cols
}